module.exports = __webpack_public_path__ + "static/Salesmate-image-fec265f677605c93b7cfc67e8b6b929b.png";